import { OrderPageTypes } from '../../../api';

export const ORDER_PAGE_TYPE_COLORS: Record<OrderPageTypes, string> = {
  [OrderPageTypes.PRIVATE]: '#2B334D',
  [OrderPageTypes.EVENT]: '#67AD5B',
  [OrderPageTypes.COURSE]: '#9C27B0',
};
